import React, {Component, PropTypes} from 'react'
import {syncEmailPdf} from 'state/actions'
import {connect} from 'react-redux'
import Modal from 'react-modal'
import i18n from 'lib/i18n'
import styles from './outboxPdfSync.scss'
import cs from 'classnames'

const _ = i18n('outbox')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

/**
 * Connect the the component to the redux store.
 */
@connect(state => ({}))
/**
 * This component handle the email PDF regenerate and synchronization for oracle
 */
export default class OutboxPdfSync extends Component {
    static propTypes = {
        email: PropTypes.object,
        callBack: PropTypes.func
    }

    /**
     * Constructor initialize component and the state.
     * @param {*} props
     */
    constructor(props) {
        super(props)
        this.state = {progress: 0}
    }

    /**
     * This handle to push the confirmation button of regenerate PDF modal.
     */
    regeneratePDF() {
        const {dispatch, email} = this.props

        this.setState({progress: 1}, ()=>{
            dispatch(syncEmailPdf(email._id))
            .then(()=>{
                this.setState({progress: 2})
            })
            .catch(()=>{
                this.setState({progress: 3})
            })
        })

    }

    render() {
        const {callBack} = this.props
        const {progress} = this.state

        return (<div>
            <Modal
                isOpen={true}
                style={customStyles}
                key={"OutboxPdfSyncModalKey"}
                className={styles.modal}
            >
                <div>
                    <div className={styles.title}>{_("pleaseWait")}</div>
                    <div className={styles.contentWrapper}>

                        {progress == 0 ? _('pleaseWaitUntilThePDFWillSync') : ""}
                        {progress == 1 ? _('inProgressPleaseWait') : ""}
                        {progress == 2 ? _('synchronisationCompleted') : ""}
                        {progress == 3 ? _('synchronisationNotCompleted') : ""}

                        <div className={styles.buttons}>
                            {progress == 0 &&
                                <div
                                    onClick={()=>callBack()}
                                    className={cs(styles.next, styles.enabled, styles.gray)}
                                >
                                    {_("cancel")}
                                </div>
                            }
                            {progress != 1 &&
                                <div
                                    onClick={()=>{
                                        if (progress == 0) {
                                            this.regeneratePDF()
                                        } else if (progress >= 2) {
                                            callBack()
                                        }
                                    }}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {_("ok")}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./components/outbox/outboxPdfSync.jsx